<template>
  <div id="btnAsideHide">
      <img v-on:click="hide" :src="$ebConfig.imgPath+'img/aside-btn.jpg'" >
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'BtnAsideHide',
  methods: {
    hide: function() {
      $('.container_main_body').addClass('container_main_body--hide');
      $('#btnAsideHide').hide();
      $('#btnAsideShow').show();
    }
  }
};
</script>
<style scoped lang="less">
#btnAsideHide {
  img {
    cursor: pointer;
  }
}
</style>
